export default "__VITE_ASSET__D8Wo08Vc__"